import React, { useState, useCallback } from 'react'
import { useTheme } from '@mui/material'
import {
  ToastContainer,
  LoaderCard,
  SpinnerWrap,
  Spinner,
  LoaderTextWrapper,
  ProgressBarContainer,
  ProgressBarFill,
  ProgressText,
  MinimizedContainer,
  MinimizedCard,
  MinimizeButton,
  Tag,
  InfoWrapper,
  MinimizedTag,
} from './GlobalLoader.styled'
import { LoaderInstance } from '../../../providers'
import { CircularProgress } from '../CircularProgress/CircularProgress'

type GlobalLoaderProps = {
  loaders: LoaderInstance[]
}

const GlobalLoader = ({ loaders }: GlobalLoaderProps) => {
  const theme = useTheme()
  const [isMinimized, setIsMinimized] = useState(false)

  const toggleMinimized = useCallback(() => {
    setIsMinimized((prev) => !prev)
  }, [])

  if (loaders.length === 0) return null

  if (isMinimized) {
    return (
      <MinimizedContainer>
        {loaders.map((loader) => {
          const percentage = loader.progress
            ? Math.round(
                (loader.progress.current / loader.progress.total) * 100
              )
            : null

          return (
            <MinimizedCard key={loader.id} onClick={toggleMinimized}>
              <CircularProgress
                percentage={percentage ?? 0}
                color={theme.palette.primary.main}
              />
              {loader.tag && <MinimizedTag>{loader.tag}</MinimizedTag>}
            </MinimizedCard>
          )
        })}
      </MinimizedContainer>
    )
  }

  return (
    <ToastContainer>
      {loaders.map((loader, index) => {
        const percentage = loader.progress
          ? Math.round((loader.progress.current / loader.progress.total) * 100)
          : null

        return (
          <LoaderCard
            key={loader.id}
            style={{
              marginBottom: index < loaders.length - 1 ? '12px' : 0,
            }}
          >
            <MinimizeButton onClick={toggleMinimized} title="Minimize">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 7H12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </MinimizeButton>
            <SpinnerWrap>
              <Spinner
                style={{
                  borderTopColor: theme.palette.primary.main,
                }}
              />
            </SpinnerWrap>
            <LoaderTextWrapper>
              {loader.text || 'Loading...'}
              {loader.progress && (
                <>
                  <InfoWrapper>
                    <ProgressText>
                      {loader.progress.label || 'Processing'}:{' '}
                      {loader.progress.current} / {loader.progress.total}
                    </ProgressText>
                    {loader.tag && <Tag>{loader.tag}</Tag>}
                  </InfoWrapper>
                  <ProgressBarContainer>
                    <ProgressBarFill
                      style={{
                        width: `${percentage}%`,
                        backgroundColor: theme.palette.primary.main,
                      }}
                    />
                  </ProgressBarContainer>
                  <ProgressText>{percentage}% complete</ProgressText>
                </>
              )}
            </LoaderTextWrapper>
          </LoaderCard>
        )
      })}
    </ToastContainer>
  )
}

export default GlobalLoader
